import React from "react";
import { Card } from "../../../../CommonElements/Hajj/Card";
import { useTranslation } from "react-i18next";
import { STACK_4 } from "./PilgrimDetails";
import { LabelValue } from "@Component/Value";

export const NusukCardData = (props) => {
  const { t } = useTranslation();
  const { isLoading } = props;

  const {
    nusuk_card_number,
    activation_date,
    card_status,
  } = props;

  const VerticalLabelValue = (props) => (
    <LabelValue loading={isLoading} direction="vertical" {...props} />
  );

  return (
    <Card header={<span className="H5">{t("NUSUK_CARD_DATA")}</span>}>
      <STACK_4>
        <VerticalLabelValue
          copyValue={nusuk_card_number}
          label={t("NUSUK_CARD_NUMBER")}
          value={nusuk_card_number || "-"}
        />
        <VerticalLabelValue
          label={t("ACTIVATION_DATE")}
          value={activation_date || "-"}
        />
        <VerticalLabelValue
          direction="vertical"
          label={t("CARD_STATUS")}
          value={card_status || "-"}
        />
      </STACK_4>
    </Card>
  );
};
